export default function TS_Study_Plan() {
  return (
    <div>
      <h1>TS Study Plan</h1>
      <p>This is the TS Study Plan page.</p>
    </div>
  );
}